import React, { useState } from "react";
import "./addCategoryDialog.scss";
import { set } from "react-hook-form";
const AddCategoryDialog = ({ handleAdding, handleClose, categoryLevel }) => {
  const [name, setName] = useState("");
  const [isFamily, setIsFamily] = useState(false);
  return (
    <div className="add-category-dialog-overlay">
      <div className="add-category-dialog-box">
        <span className="close-icon" onClick={() => handleClose(false)}>
          ×
        </span>
        <h2>הוסף מחלקה חדשה</h2>
        <p>הזן שם למחלקה החדשה שברצונך להוסיף.</p>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleAdding(name, isFamily);
          }}
        >
          <div className="details">
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="שם"
            />
            <label className="family-checkbox">
              <input
                className="checkbox"
                type="checkbox"
                checked={isFamily}
                onChange={() => setIsFamily(!isFamily)}
              />
              <span>מקבץ</span>
            </label>
          </div>
          <button type="submit">הוסף</button>
        </form>
      </div>
    </div>
  );
};
export default AddCategoryDialog;
